import * as Factory from 'factory.ts';
import { nullable, randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import { LocationType } from '@rtls/core/models/location/location-type.model';
import { builtInTypeFactory } from '@rtls/core/models/base/built-in-type.factory';

export const locationTypeFactory = Factory.makeFactory<LocationType>({
	id: Factory.each((i) => nullable(i)),
	key: Factory.each(() => randomName()),
	translation: Factory.each(() => nullable(randomWord())),
	builtInType: Factory.each(() => builtInTypeFactory.build()),
	externalId: Factory.each(() => nullable(randomWord())),
	providerId: Factory.each(() => nullable(randomWord())),
});
